import { paginationSearchSchema } from '@/lib/pagination'
import type { IntegrationDetailSearch } from './IntegrationDetailPage'
import {
  INTEGRATION_DETAIL_TABS,
  type IntegrationDetailTab,
} from './integration-detail-model'

function parseSharedSearch(
  search: Record<string, unknown>
): IntegrationDetailSearch {
  return {
    ...paginationSearchSchema.parse(search),
    tab:
      typeof search.tab === 'string' &&
      INTEGRATION_DETAIL_TABS.includes(search.tab as IntegrationDetailTab)
        ? (search.tab as IntegrationDetailTab)
        : undefined,
    intent: search.intent === 'connect' ? 'connect' : undefined,
    check: typeof search.check === 'string' ? search.check : undefined,
    run: typeof search.run === 'string' ? search.run : undefined,
  }
}

export function parseProviderIntegrationSearch(
  search: Record<string, unknown>
): IntegrationDetailSearch {
  return {
    ...parseSharedSearch(search),
    connection:
      typeof search.connection === 'string' ? search.connection : undefined,
  }
}

export function parseAccountIntegrationSearch(
  search: Record<string, unknown>
): IntegrationDetailSearch {
  return {
    ...parseSharedSearch(search),
    repository:
      typeof search.repository === 'string' ? search.repository : undefined,
  }
}

export function parseServiceIntegrationSearch(
  search: Record<string, unknown>
): IntegrationDetailSearch {
  return {
    connection:
      typeof search.connection === 'string' ? search.connection : undefined,
  }
}
